<template>
	<div class="mobile-nav-header mb-6">
		<div class="border-b border-primary bg-shade-2 fixed flex w-full z-10">
			<CMobileUpButton />

			<component
				:is="navItems ? 'button' : 'div'"
				class="mobile-nav-header__button flex button--no-style text-left w-full items-center justify-between pr-4"
				@click="navItems ? isOpen = true : null"
			>
				<div>
					<div v-if="contextLabel" class="sz-1 text-subtle font-medium">{{ contextLabel }}</div>
					<h1 class="sz-3 mb-0 font-inherit">{{ header || title }}</h1>
				</div>
				<Inline v-if="navItems" svg="chevron-down" class="text-icon-subtle" />
			</component>

			<Transition name="el-zoom-in-top">
				<div
					v-if="navItems && isOpen"
					class="mobile-nav-header__menu bg-primary w-full fixed pb-4"
				>
					<div class="p-4 flex justify-between">
						<h1 class="mb-0">{{ title }}</h1>
						<button class="button--no-style p-4 -m-4" @click="isOpen = false">
							<Inline svg="ex" class="text-icon-subtle" />
						</button>
					</div>
					<ElMenu
						ref="menu"
						mode="horizontal"
					>
						<ElMenuItem
							v-for="item in navItems"
							:key="item.name"
							@click="isOpen = false"
						>
							<RouterLink
								:to="{ name: item.name }"
								class="block px-4 py-3 no-underline"
								:class="{
									'active-link': $route.name === item.name
								}"
							>
								{{ item.displayName }}
							</RouterLink>
						</ElMenuItem>
					</ElMenu>
				</div>
			</Transition>

			<Transition name="fade">
				<div
					v-if="isOpen"
					class="mobile-nav-header__backdrop z-1"
					@click="isOpen = false"
				/>
			</Transition>
		</div>
	</div>
</template>

<script>
	import { defineComponent, ref, watch } from 'vue';
	import { Menu, MenuItem, Popover, Message } from '@cognitoforms/element-ui';

	import CMobileUpButton from 'src/components/navigation/MobileUpButton.vue';

	export default defineComponent({
		name: 'CMobileNavHeader',
		components: {
			ElMenu: Menu,
			ElMenuItem: MenuItem,
			ElPopover: Popover,
			CMobileUpButton
		},
		props: {
			navItems: {
				type: Array,
				required: true
			},
			contextLabel: {
				type: String,
				default: null
			},
			title: {
				type: String,
				required: true
			},
			header: {
				type: String,
				default: null
			}
		},
		setup() {
			const isOpen = ref(false);

			watch(() => isOpen.value, (val) => {
				if (val) Message.closeAll();
			});

			return {
				isOpen
			};
		}
	});
</script>
<style lang="scss" src="@cognitoforms/styles/global/_motion.scss"></style>
<style lang="scss">
.mobile-nav-header {

	&__button {
		height: $mobile-up-button-height;
		margin-left: $mobile-up-button-width;
	}

	&__backdrop {
		position: fixed;
		bottom: 0;
		left: 0;
		right: 0;
		top: 0;
		z-index: $z-1;
		background: var(--bg-overlay);
	}

	&__menu {
		z-index: $z10;
	}

	a {
		color: var(--text-primary) !important;
	}

	.active-link {
		background: var(--bg-selected);
	}
}

</style>